import React from "react";
import Link from "next/link";

import { useStrainPageContext } from "@/context/StrainPageContext";
import { StrainRelative } from "@/custom-types/StrainV2";
import { useEventTracker } from "@/hooks/useEventTracker";

import StrainLineageNuclei from "./StrainLineageNuclei";

type Props = {
  strain: StrainRelative;
  altText: string;
  parentOrChild: "parent" | "child";
};

const StrainLineageLink = ({ altText, parentOrChild, strain }: Props) => {
  const { eventPage } = useStrainPageContext();
  const { name, slug, id, symbol, topTerpName } = strain;
  const { publishEvent } = useEventTracker();

  return (
    <Link
      href={`/strains/${slug}`}
      onClick={() => {
        publishEvent({
          // @ts-ignore -- TODO: Fix publishEvent types (https://leafly.atlassian.net/browse/SHH-1133)
          "Strain ID": id,
          action: "Click",
          category: "Strain Lineage",
          label: `${eventPage} lineage section click`,
        });
      }}
      className="flex flex-col items-center text-center"
    >
      <StrainLineageNuclei
        altText={altText}
        mainOrRelative={"relative"}
        strainSymbol={symbol}
        topTerpName={topTerpName}
      />
      <div>
        <div>{name}</div>
        <div className="text-green text-xs">{parentOrChild}</div>
      </div>
    </Link>
  );
};

export default StrainLineageLink;
